import React from 'react';
import { Link } from 'react-router-dom';
import '../components/TrainingCom.css'
import pod from '../assets/pod.jpg'
import moon from '../assets/moon.jpg'


const TrainingCom = () => {
    return (
        <div className='trainig'>
            <div className='left'>
                <h1>Taining</h1>
                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ratione, et maxime numquam ipsam temporibus dolor, 
                    natus pariatur sit cum tempora sint quidem fugiat veniam quis?</p>
                <Link to='/Contact' className='btn'>Contact</Link>
            </div>
            <div className='right'>
                <div className='img-container'>
                    <div className='image-stack top'>
                        <img src={moon} alt="/" className='img' />
                    </div>
                    <div className='image-stack bottom'>
                        <img src={pod} alt="/" className='img' />
                    </div>
                </div>
            </div>
            
        </div>
    );
}

export default TrainingCom;
